import React, { Component } from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { observer, inject } from 'mobx-react';
import Icon from '../Icon';
import styles from './style';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';

const { isMini } = DeviceInfo;

interface Props {
    pageName?: string;
    showBindNotice?: boolean;
    toggleShowBindNotice?(show: boolean): void;
    openBindView?(): void;
}

@inject((store: RootStoreInterface) => ({
    showBindNotice: store.bindNotice.showBindNotice,
    toggleShowBindNotice: store.bindNotice.toggleShowBindNotice,
    openBindView: store.bindNotice.openBindView,
    pageName: store.pageName
}))
@observer
class BindNotice extends Component<Props> {
    public onPressBindNotice = () => {
        const { toggleShowBindNotice, openBindView, pageName } = this.props;

        if(!isMini){
            toggleShowBindNotice(false);
        }
        
        openBindView();
        qav({
            page: pageName,
            module: 'bindNotice',
            path: [{ title: '订单绑定提示条点击', position: '0' }],
            operType: 'click'
        });
    };

    public render() {
        const { showBindNotice } = this.props;
        if (!showBindNotice) {
            return null;
        }
        return (
            <TouchableOpacity
                activeOpacity={1}
                style={styles.bindNotice}
                onPress={this.onPressBindNotice}
                {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.UN_BIND)}
            >
                <View style={styles.bindNoticeLeft}>
                    <Icon code="&#xe6cf;" style={styles.noticeIcon} />
                    <Text
                        style={[styles.bindNoticeText, { width: '100%', paddingRight: 20 }]}
                        numberOfLines={1}
                    >
                        {isMini ? '检测到您未登录时所下的订单' : '为方便查询管理，请绑定订单至会员账号'}
                    </Text>
                </View>
                <View style={styles.bindNoticeRight}>
                    <Text style={styles.bindNoticeText}>{isMini ? '去查看' : '去绑定'}</Text>
                    <Icon code="&#xf03e;" style={[styles.bindNoticeIcon]} />
                </View>
            </TouchableOpacity>
        );
    }
}
export default BindNotice;
